import * as React from 'react';
import * as styles from './Header.css';

export const Header = ({ controls }: { controls: React.ReactNode }) => {
  return (
    <div className={styles['header-container']}>
      <div className={styles['header']}>
        <div className={styles['content']}>
          <h1 className={styles['title']}>
            Бесплатно подберём и&nbsp;поможем купить&nbsp;квартиру от&nbsp;застройщика
          </h1>
          <div className={styles['controls']}>{controls}</div>
        </div>
      </div>
    </div>
  );
};
